module.exports = __webpack_public_path__ + "static/img/icon-phone.428dc60d.svg";